import { gql } from "generated-graphql";

export const GET_CUPA_PREFERENCE_PROFILE = gql(`
  query CupaPreferenceProfile($cupaCode: String!) {
    cupaPreferenceProfile(cupaCode: $cupaCode) {
      id
      cupaCode
      summary
      model
      createdAt
      sourceCount
      substantiveCount
      preferenceSignalCount
      preferences {
        title
        scope
        recommendation
        confidence
        evidence {
          decisionId
          date
          module
          facilityName
          excerpt
        }
      }
    }
  }
`);
